<template>
  <div>
    <label>
      <slot name="label"></slot>
    </label>
    <input
      type="text"
      v-model.trim="inputVal"
      v-focus="focus"
      v-on:keydown.enter.prevent
      autocomplete="off"
    />
    <transition name="fade">
      <p v-if="valid.$invalid && showError" class="error">{{ errorMessage }}</p>
    </transition>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["value", "valid", "focus", "showError", "errorMessage"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
